var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowbackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.24906e-06 7C-2.58703e-06 3.13408 3.1341 9.49927e-07 7 6.1196e-07C10.8659 2.7399e-07 14 3.13408 14 7C14 10.8659 10.8659 14 7 14C3.1341 14 -1.9111e-06 10.8659 -2.24906e-06 7ZM6.47626 3.67182L5.57262 4.57546L8.04682 7.05092L5.35118 9.74656L6.251 10.6464L9.8509 7.04644L6.47626 3.67182Z",
    fill: "#0E716A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 14 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowbackbutton);
export default __webpack_public_path__ + "static/media/arrowbackbutton.985326895454109da4d7fe36a90026f2.svg";
export { ForwardRef as ReactComponent };